export default {
  badge: "Badge",
  close: "Fermer",
  dataIterator: {
    noResultsText: "Aucun enregistrement correspondant trouvé",
    loadingText: "Chargement de l'élément..."
  },
  dataTable: {
    itemsPerPageText: "Lignes par page:",
    ariaLabel: {
      sortDescending: "Tri décroissant.",
      sortAscending: "Tri croissant.",
      sortNone: "Non trié.",
      activateNone: "Activer pour supprimer le tri.",
      activateDescending: "Activer pour trier par ordre décroissant.",
      activateAscending: "Activer pour trier par ordre croissant."
    },
    sortBy: "Trier par"
  },
  dataFooter: {
    itemsPerPageText: "Élements par page:",
    itemsPerPageAll: "Tous",
    nextPage: "Page suivante",
    prevPage: "Page précédente",
    firstPage: "Première page",
    lastPage: "Dernière page",
    pageText: "{0}-{1} de {2}"
  },
  datePicker: {
    itemsSelected: "{0} sélectionnés",
    nextMonthAriaLabel: "Le mois prochain",
    nextYearAriaLabel: "L'année prochaine",
    prevMonthAriaLabel: "Le mois précédent",
    prevYearAriaLabel: "Année précédente"
  },
  noDataText: "Aucune donnée disponible",
  carousel: {
    prev: "Visuel précédent",
    next: "Visuel suivant",
    ariaLabel: {
      delimiter: "Carousel slide {0} of {1}"
    }
  },
  calendar: {
    moreEvents: "{0} plus"
  },
  fileInput: {
    counter: "{0} fichiers",
    counterSize: "{0} fichiers ({1} au total)"
  },
  timePicker: {
    am: "AM",
    pm: "PM"
  },
  pagination: {
    ariaLabel: {
      wrapper: "Navigation de pagination",
      next: "Page suivante",
      previous: "Page précédente",
      page: "Aller à la page {0}",
      currentPage: "Page actuelle, Page {0}"
    }
  },
  error_occured: "Erreur survenue",
  form_error: "Le formulaire contient des erreurs",
  "You have running request on this report": "Vous avez déja une demande en cours",
  app_description: "Plateforme d'envoi de sms",
  page_not_found: "Page introuvable",
  page_forbidden: "Page non autorisée",
  cancel: "Annuler",
  clear: "Effacer",
  ok: "Ok",
  now: "Maintenant",
  date: "Date",
  hour: "Heure",
  dt_elements: "{0} Elément(s)",
  others: "Autres",
  request: "Requête",
  response: "Réponse",
  security: {
    title: "Connexion",
    description: "Plateforme d'envoi de SMS",
    username: {
      title: "Nom d'utilisateur"
    },
    password: {
      title: "Mot de passe"
    },
    otp: {
      title: "One Time Password",
      title1: "Code otp",
      placeholder: "Veuiller entrer le code OTP reçu",
      resend: "Renvoyer",
      verify: "Vérifier",
      bad_credentials: "Code otp incorrect",
      errors: {
        E102: "Le code otp a expiré",
        E103: "Le code otp est invalide",
        E104: "Le code otp a deja été utilisé",
        unauthorized: "Accès refusé"
      }
    },
    form: {
      submit: "Connexion",
      bad_credentials: "Username ou mot de passe incorrectes"
    }
  },
  actions: {
    title: "Actions"
  },
  roles: {
    ROLE_SUPER_ADMIN: "Super Administrateur",
    ROLE_ADMIN: "Administrateur",
    ROLE_CLIENT: "Partenaire"
  },
  menu: {
    dashboard: "Tableau de bord",
    users: "Utilisateurs",
    logout: "Déconnexion",
    provisions: "Mouvements",
    pushes: {
      title: "Pushes",
      simple: "Simple",
      advanced: "Avancé"
    },
    sms: {
      title: "SMS",
      sent: "Envoyés",
      queue: "En file"
    },
    systems: {
      title: "Configurations",
      servers: "Serveurs",
      directories: "Répertoires",
      priorities: "Files"
    },
    archives: "Archives",
    profile: "Mon compte",
    developer: {
      title: "Développeurs",
      sent: "Envoyer un sms",
      balance: "Consulter le solde"
    }
  },
  btn: {
    refresh: "Actualiser",
    save: "Enregistrer",
    confirm: "Confirmer",
    close: "Fermer",
    cancel: "Annuler",
    send: "Envoyer",
    filter: "Filtrer",
    details: "Détails",
    ok: "Ok",
    yes: "Oui",
    no: "Non",
    edit: "Mettre à jour",
    date: "Sélectionner une date",
    export: {
      title: "Exporter",
      info: "Exporter sous excel"
    },
    changePassword: "Modifier le mot de passe",
    copy: "Copier",
    homepage: "Page d'accueil",
    dlrInfo: "Description des accusés"
  },
  delete: {
    confirm: "Êtes vous sûre de vouloir supprimer ?"
  },
  dashboard: {
    title: "Tableau de bord"
  },
  telcos: {
    mtn: "MTN Cameroun",
    ocm: "Orange Cameroun",
    nex: "Nexttel Cameroun",
    ctl: "Camtel",
    other: "Autres"
  },
  users: {
    title: "Utilisateurs",
    list: {
      title: "Liste des utilisateurs"
    },
    create: {
      title: "Nouvel utilisateur",
      success: "Utilisateur enregistré"
    },
    show: {
      title: "Informations de l'utilisateur"
    },
    edit: {
      title: "Modifier l'utilisateur {0}",
      success: "Utilisateur mis à jour"
    },
    sid: {
      title: "Associations des sender ID",
      success: "Utilisateur mis à jour"
    },
    search: {
      title: "Entrer un nom d'utilisateur"
    },
    priority: {
      title: "Modifier la file de traitement",
      success: "File modifiée"
    },
    changePassword: {
      title: "Modifier le mot de passe",
      success: "Mot de passe modifié"
    },
    model: {
      created: {
        title: "Date de création"
      },
      updated: {
        title: "Dernière mis à jour"
      },
      login: {
        title: "Username",
        title2: "Nom d'utilisateur",
        required: "Nom d'utilisateur requis",
        min_length: "Nom d'utilisateur trop court. {0} caractères min",
        max_length: "Nom d'utilisateur trop long. {0} caractères max",
        already_exists: "Nom d'utilisateur déja existant"
      },
      sid: {
        title: "Expéditeur(s)",
        desc: "Liste des expéditeurs configurés",
        required: "Expéditeur(s) requis",
        invalid: "L'un des expéditeurs est invalide"
      },
      name: {
        title: "Nom complet",
        required: "Nom complet requis",
        min_length: "Nom trop court. {0} caractères min",
        max_length: "Nom trop long. {0} caractères max"
      },
      priority: {
        title: "File",
        title2: "File de traitement",
        placeholder: "Sélectionner une file de traitement",
        required: "File de traitement requise"
      },
      status: {
        title: "Statut",
        title2: "Cocher pour activer l'utilisateur",
        title3: "Décocher pour desactiver l'utilisateur",
        enabled: "Activé",
        disabled: "Désactivé"
      },
      otp: {
        title: "Otp",
        title2: "Cocher pour activer l'OTP",
        title3: "Décocher pour desactiver l'OTP",
        enabled: "Oui",
        disabled: "Non",
        display_msg: "Temps avant regénération d'un nouveau code"
      },
      anticonstitutionnal: {
        title: "Cocher pour activer la restriction de contenu",
        title1: "Décocher pour désactiver la restriction de contenu",
        enabled: "Oui",
        disabled: "Non",
      },
      balance: {
        title: "Balance"
      },
      expiredAt: {
        title: "Date d'expiration du compte"
      },
      role: {
        title: "Rôle",
        title2: "Sélectionner un rôle",
        admin: "Admin",
        super_admin: "Super Admin",
        client: "Client",
        invalid: "Rôle invalide",
        required: "Rôle requis"
      },
      billingType: {
        title: "Facturation",
        title2: "Sélectionner le type de facturation",
        postpaid: "PostPayé",
        prepaid: "PréPayé",
        required: "Type facturation requis",
        invalid: "Type facturation invalide"
      },
      accountType: {
        title: "Type de compte",
        title1: "Cocher pour activer l'internationnal",
        title2: "Décocher pour désactiver l'internationnal",
        national: "National",
        internationnal: "International"
      },
      notification: {
        title: "Notifications",
        title1: "Cocher pour activer les notifications",
        title2: "Décocher pour desactiver les notifications"
      },
      password: {
        title: "Mot de passe",
        title2: "Confirmer le mot de passe",
        title3: "Nouveau mot de passe",
        title4: "Confirmer le nouvau mot de passe",
        required: "Mot de passe requis",
        min_length: "Mot de passe trop court, {0} caractères minimum",
        max_length: "Mot de passe trop long, {0} caractères maximum",
        sameAs: "Les deux mots de passe doivent correspondre"
      },
      oldPassword: {
        title: "Ancien mot de passe",
        required: "Ancien mot de passe requis",
        invalid: "Ancien mot de passe incorrect"
      },
      apiKey: {
        title: "Clé d'api"
      },
      lastLogin: {
        title: "Dernière connexion"
      }
    },
    btn: {
      new: "Nouvel utilisateur",
      list: "Utilisateurs",
      edit: "Modifier l'utilisateur",
      provision: "Effectuer un mouvement",
      changePriority: "Cliquer pour modifier la file",
      show: "Informations de l'utilisateur",
      sid: "Affecter des expéditeurs de messages à"
    },
    profile: {
      title: "Mon compte",
      infos: "Informations du compte",
      api: "Developpeurs",
      apiKey: {
        confirmChange: "Êtes vous sûre de vouloir régénérer la clé d'api ?",
        success: "Clé d'api régénérer"
      }
    }
  },
  provisions: {
    title: "Mouvements",
    notFound: "Mouvement introuvable",
    show: {
      title: "Détail du mouvement"
    },
    filter: {
      title: "Filtrer les mouvements"
    },
    create: {
      title: "Effectuer un mouvement sur {0}",
      success: "Mouvement effectué"
    },
    model: {
      operation: {
        title: "Opération",
        debit: "Débit",
        credit: "Crédit",
        required: "Opération requise",
        invalid: "Opération invalide"
      },
      created: {
        title: "Date",
        title2: "Date du mouvement"
      },
      smsPreviousBalance: {
        title: "Solde précédent"
      },
      currentBalance: {
        title: "Solde actuel"
      },
      user: {
        title: "Compte"
      },
      doBy: {
        title: "Effectué par"
      },
      smsCount: {
        title: "SMS",
        required: "Nombre de SMS requis",
        invalid: "Nombre de SMS invalide"
      },
      smsPrice: {
        title: "Prix des SMS (XAF)",
        required: "Prix des SMS requis",
        invalid: "Prix des SMS invalide"
      },
      comment: {
        title: "Commentaire",
        required: "Commentaire",
        maxLength: "Commentaire trop long. {0} caractères max"
      }
    }
  },
  pushes: {
    model: {
      user: {
        title: "Effectuer le push à partir d'un compte",
        placeholder: "Commencer à taper le nom d'un compte",
        disable: "Ce compte est désactivé",
        insufficient_balance: "Solde du compte vide"
      },
      sendDate: {
        title: "Date d'envoi: {0}"
      }
    },
    simple: {
      title: "Push simple",
      not_found: "Push simple introuvable",
      btn: {
        new: "Nouveau push",
        show: "Informations sur le push",
        list: "Liste push simple",
        details: "Détails du traitement"
      },
      show: {
        title: "Informations sur le push"
      },
      list: {
        title: "Liste des push simple"
      },
      create: {
        title: "Nouveau push simple",
        description: "Effectuer un push",
        description2: "Programmer le push",
        confirm: {
          title: "Confirmer le push simple"
        },
        error: {
          credit: "Crédit insuffisant",
          credit2: "Solde du compte insuffisant pour effectuer le push",
          accountDisable: "Ce compte est désactivé"
        },
        success: "Push enregistré pour traitement"
      },
      filter: {
        title: "Filtrer les push simple"
      },
      details: {
        title: "Détails du push simple",
        filter: {
          title: "Filtrer les détails"
        }
      },
      model: {
        account: {
          title: "Compte",
          placeholder: "Commencer à taper un nom de compte"
        },
        created: {
          title: "Date",
          title2: "Date de création",
          placeholder: "Sélectionner une plage de date"
        },
        sender: {
          title: "Expéditeur",
          placeholder: "Nom de l'expéditeur",
          placeholder2: "Entrer le nom de l'expéditeur",
          required: "Expéditeur requis",
          invalid: "Expéditeur invalide"
        },
        total: {
          title: "Total",
          title2: "Total destinataires"
        },
        treated: {
          title: "Valides(s)",
          title2: "Echecs(s)"
        },
        status: {
          title: "Statut",
          treated: "Traité",
          init: "En attente",
          running: "En cours",
          scheduled: "Programmé",
          rejected: "Rejeté"
        },
        message: {
          title: "Message",
          placeholder: "Entrer le message à envoyer",
          required: "Message requis",
          maxLength: "Message trop long {0} caractères max"
        },
        sendDate: {
          title: "Date d'envoi",
          title2: "A envoyer le {0} à {1}",
          title3: "Cliquer pour modifier la date d'envoi"
        },
        smsSize: {
          title: "Taille du SMS"
        },
        doBy: {
          title: "Effectué par"
        },
        hidePhone: {
          title: "Cocher pour tronquer les numéros",
          hidden: "Numéros de téléphone tronqués"
        },
        phone: {
          title: "Numéro de téléphone",
          placeholder: "Entrer un numéro de téléphone"
        },
        numbers: {
          title: "Numéros de téléphone",
          title2: "Nombre de contacts",
          title3: "Numéro",
          placeholder: "Entrer un numéro de téléphone par ligne",
          invalid:
            "Nombre de numéros valide doit être compris entre 1 et 10000",
          hint: "{0} Numéros",
          required: "Numéros de téléphone requis"
        }
      }
    },
    advanced: {
      title: "Push avancé",
      not_found: "Push avancé introuvable",
      btn: {
        new: "Nouveau push",
        show: "Informations sur le push avancé",
        list: "Liste push avancé",
        details: "Détails du traitement",
        template: "Télécharger un template"
      },
      create: {
        title: "Nouveau push avancé",
        title2: "Sélectionner un fichier puis demarrer l'envoi",
        title3: "Conseils",
        description:
          "Vous pouvez créer votre fichier csv à partir d'un fichier Microsoft excel contenant 3 colonnes puis enregistrer au format csv séparateur point virgules <;>.<br><br>1. La première colonne le numéro de téléphone.<br>2. La deuxème colonne contenant l'expéditeur.<br>3. La troixième colonne contenant le message",
        confirm: {
          title: "Confirmer le push avancé"
        },
        success: "Push enregistré pour traitement"
      },
      filter: {
        title: "Filtrer les push avancé"
      },
      details: {
        title: "Détails du push avancé",
        show: {
          title: "Détails de la ligne traité"
        },
        filter: {
          title: "Filtrer les détails"
        },
        model: {
          created: {
            title: "Date",
            title2: "Date de création"
          },
          sender: {
            title: "Expéditeur"
          },
          phone: {
            title: "Destinataire",
            placeholder: "Numéro de téléphone du destinataire"
          },
          status: {
            title: "Statut",
            title2: "Statut de traitement",
            placeholder: "Sélectionner un status de traitement",
            treated: "Traité",
            untreated: "Non traité",
            "400": "Ligne invalide",
            "200": "Traité",
            "401": "Echec numéro",
            "402": "Echec numéro",
            "404": "Echec balance",
            "600": "Echec paramètres",
            "-100": "Echec réseau",
            "500": "Echec serveur",
            "-500": "File error",
            "-502": "Echec encodage",
            "-501": "Echec format ligne"
          },
          cost: {
            title: "Coût",
            title2: "Nombre de SMS"
          },
          content: {
            title: "Message"
          },
          line: {
            title: "Numéro ligne",
            title2: "Numéro de ligne à partir du quel afficher",
            placeholder: "Afficher à partir de la ligne"
          },
          sendDate: {
            title: "Date d'envoi"
          },
          submitAt: {
            title: "Date soumission"
          },
          submitDelay: {
            title: "Délai de soumission"
          },
          file: {
            title: "Fichier"
          }
        },
        btn: {
          show: "Voir plus de détails"
        }
      },
      model: {
        created: {
          title: "Date",
          title2: "Date de création",
          placeholder: "Sélectionner une plage de date"
        },
        account: {
          title: "Compte",
          placeholder: "Commencer à taper pour selectionner un compte"
        },
        doBy: {
          title: "Effectué par"
        },
        uri: {
          title: "Fichier"
        },
        file: {
          title: "Sélectionner un fichier",
          title2: "Fichier csv sélectionné",
          help:
            "Charger un fichier csv séparateur point virgule <;> (10MB max)",
          error: {
            minSize: "Fichier sélectionné vide",
            maxSize: "Taille maximale requise dépassée. {size} max",
            extension: "Fichier sélectionné non supporté",
            timeout: "Temps de chargement dépassé",
            abort: "Chargement annulé",
            network: "Problème connexion",
            denied: "Accès refusé",
            required: "Fichier requis"
          }
        },
        status: {
          title: "Statut",
          init: "En cours",
          new: "En attente",
          error: "Echec",
          success: "Traité",
          exit: "Interrompu"
        },
        size: {
          title: "Taille"
        },
        lines: {
          title: "Lignes",
          title2: "Nombre lignes totales"
        },
        hidePhone: {
          title: "Cocher pour tronquer les numéros",
          hidden: "Numéros de téléphone tronqués"
        },
        submitted: {
          title: "Valides",
          title2: "Nombre lignes valides"
        },
        errorLine: {
          title: "Echecs",
          title2: "Nombre lignes echecs"
        },
        errorReason: {
          title: "Raison erreur",
          FILE_ERROR_OVERSIZE:
            "Taille du fichier déposé trop grande: Vous pourvez découper vos fichiers lourd en plusieurs fichiers",
          FILE_ERROR_INTERNAL_IO: "Une erreur est survenue lors du traitement",
          SMS_SEND_ERROR_USER_LINE_INCORRECT_FORMAT:
            "Le fichier contient contient plusieurs lignes mal formatées",
          ERROR_AUTHENTIFICATION:
            "Erreur d'authentification dans le fichier de traitement",
          ERROR_BALANCE:
            "Erreur lié au solde du compte insuffisant pour continuer le traitement du fichier",
          EMPTY_FILE: "Le fichier ne contient aucune ligne",
          SMS_SEND_ERROR_BAD_NUMBER:
            "Le fichier contient plusieurs numéros erronés",
          SMS_SEND_ERROR_CONTRY_NOT_ENABLE: "Indicatif pays non autorisé",
          "ERROR_UNKWNOW:400": "Une erreur est survenue lors du traitement d'une ligne du fichier",
          FILE_ERROR_NAMESYNTAX: "Erreur sur le nom du fichier",
          FILE_ERROR_INCORRECT_LINE_COUNT:
            "Nombre de ligne dans le fichier invalide",
          FILE_ERROR_SGC_TRAITED: "Fichier déjà traité pour la période",
          "File seems allready reloaded.Contact admin":
            "Fichier déjà rechargé.",
          INTERNAL_SEND_MESSAGE_EXCEPTION: "Format message incorrect",
          ERROR_INTERNAL_NETWORK: "Erreur de communication",
          "INTERNAL ERROR": "Erreur survenue"
        }
      }
    }
  },
  sms: {
    notFound: "Sms introuvable",
    sent: {
      title: "SMS envoyés",
      show: {
        title: "Détails du sms envoyé"
      },
      filter: {
        title: "Filtrer les sms"
      },
      download: {
        title: "Exporter les sms",
        success: "Génération de l'export en cours de traitement",
        already_in_process: "Un export est déja en cours de traitement",
        no_data: "Aucune donnée trouvée",
        limit_row_exceeded: "Nombre maximum de données dépassé. Choisir une période reduite"
      },
      status: {
        title: "Description des statuts d'accusés",
        title2: "Sélectionner un statut pour afficher la description",
        placeholder: "Sélectionner un status"
      }
    },
    queue: {
      title: "SMS dans la file d'envoi",
      show: {
        title: "Détails du sms en file"
      },
      filter: {
        title: "Filtrer les sms"
      }
    },
    model: {
      created: {
        title: "Date",
        title2: "Date de création",
        placeholder: "Sélectionner une plage de date"
      },
      account: {
        title: "Compte",
        placeholder: "Commencer à saisir un nom d'utilisateur"
      },
      sendDate: {
        title: "Date d'envoi"
      },
      dlrDate: {
        title: "Date accusé"
      },
      sentAt: {
        title: "Envoyer à"
      },
      phone: {
        title: "Destinataire",
        placeholder: "Entrer un destinataire",
        truncate: "Numéro de téléphone tronqué"
      },
      smppId: {
        title: "Smpp ID"
      },
      attempt: {
        title: "Nombre de tentative(s)"
      },
      smppReponse: {
        title: "Réponse SMPP"
      },
      operator: {
        title: "Opérateur",
        placeholder: "Sélectionner un opérateur",
        mtn: "MTN Cameroun",
        ocm: "Orange Cameroun",
        ctl: "Camtel",
        nex: "Nexttel Cameroun",
        other: "Autre"
      },
      sender: {
        title: "Expéditeur",
        placeholder: "Entrer un nom d'expéditeur"
      },
      cost: {
        title: "Coût"
      },
      content: {
        title: "Message"
      },
      dlr: {
        title: "Accusé",
        title2: "Accusé de reception",
        placeholder: "Sélectionner un statut d'accusé",
        PENDING: "Attente",
        DELIVERED: "Délivré",
        NOT_DELIVERED: "Non délivré",
        FAILED: "Echec",
        ABSENT_SUBSCRIBER: "Numéro absent",
        COMMAND_REJECTED: "Commande rejeté",
        ERROR_UNKNOWN: "Statut inconnu",
        MESSAGE_EXPIRED: "Expiré",
        MESSAGE_SYNTAX_ERROR: "Erreur message",
        MOBILE_STATION_APPLICATION_ERROR: "Erreur app mobile",
        MOBILE_STATION_ERROR: "Erreur mobile",
        NETWORK_ERROR: "Erreur réseau",
        NETWORK_FAILURE: "Echec réseau",
        SERVICE_TEMPORARY_NOT_AVAILABLE: "Service indisponible",
        SYNTAX_ERROR: "Erreur syntaxe",
        TP_DCS_REJECTED: "DCS rejeté",
        TP_DU_REJECTED: "TP DU rejeté",
        TP_PID_REJECTED: "TP PID rejeté",
        UNKNOWN_SUBSCRIBER: "Mobile inconnue",
        CARRIED_SUBSCRIBER: "Abonné porté",
        MESSAGE_READ: "Message lu",
        MESSAGE_DELETED: "Message supprimé",
        MESSAGE_INTERMEDIATE_STATE: "Message intermediaire",
        MESSAGE_FORWARDED: "Message transféré",
        SENT: "Envoyé",
        NONE: "Erreur"
      },
      source: {
        title: "Source",
        placeholder: "Sélectionner une source de sms",
        api_public: "API",
        file__bgfi: "BGFI-FILE",
        file__input_bulk: "INPUT-FILE",
        file__csv_bulk: "CSV-FILE",
        file__sgc_deco: "SGC-DECO-FILE",
        file__sgc_disp: "SGC-DISP-FILE",
        file__sgc_mouv: "SGC-MOUV-FILE",
        file__sgc_seui: "SGC-SEUI-FILE",
        file__sgc_sold: "SGC-SOLD-FILE",
        push_web: "WEB"
      },
      email: {
        title: "Adresse email de reception",
        placeholder: "Adresse email de reception du lien",
        required: "Adresse email requise",
        invalid: "Adresse email invalide"
      }
    }
  },
  system: {
    servers: {
      title: "Serveurs",
      notFound: "Serveur introuvable",
      btn: {
        new: "Nouveau serveur",
        edit: "Modifier les informations du serveur",
        delete: "Supprimer ce serveur"
      },
      create: {
        title: "Nouveau serveur",
        success: "Serveur ajouté"
      },
      edit: {
        title: "Modifier le serveur",
        success: "Serveur modifié"
      },
      delete: {
        title: "Êtes vous sûre de vouloir supprimer ce serveur ?",
        success: "Serveur supprimé",
        unable: "Impossible de supprimer ce serveur"
      },
      model: {
        name: {
          title: "Nom",
          placeholder: "Nom du serveur",
          required: "Nom requis",
          length: "Le nom doit être compris entre {0} et {1} caractères"
        },
        type: {
          title: "Type",
          title2: "Type de serveur",
          placeholder: "Sélectionner le type de serveur",
          mmg: "MMG",
          ozeki: "OZEKI",
          required: "Type de serveur requis",
          invalid: "Type de serveur invalide"
        },
        username: {
          title: "Username",
          placeholder: "Nom d'utilisateur de connexion",
          required: "Username requis",
          maxLength: "Username trop long. {0} caractères max"
        },
        password: {
          title: "Password",
          title2: "Mot de passe",
          placeholder: "Mot de passe de connexion",
          required: "Mot de passe requis",
          maxLength: "Mot de passe trop long. {0} caractères max"
        },
        host: {
          title: "Hôte",
          placeholder: "Adresse IP du serveur",
          required: "Hôte requis",
          invalid: "Adresse hôte invalide"
        },
        port: {
          title: "Port",
          placeholder: "Port du serveur",
          required: "Port requis",
          invalid: "Port invalide"
        },
        id: {
          title: "Instance"
        }
      }
    },
    directories: {
      title: "Répertoires de traitement",
      notFound: "Répertoire introuvable",
      btn: {
        new: "Nouveau répertoire",
        edit: "Modifier le repertoire de traitement",
        delete: "Supprimer ce repertoire"
      },
      create: {
        title: "Nouveau répertoire de traitement",
        success: "Répertoire enregistré"
      },
      edit: {
        title: "Modifier le répertoire de traitement",
        success: "Répertoire modifié"
      },
      delete: {
        title: "Êtes vous sûre de vouloir supprimer ce répertoire ?",
        success: "Répertoire supprimé"
      },
      model: {
        application: {
          title: "Application",
          placeholder: "Nom de la classe de traitement",
          required: "Nom de l'application requis",
          invalid: "Nom invalide. caractères alphanumériques et <.-_> autorisés"
        },
        alertFileNotTreatedSince: {
          title: "Alerte non traitement fichier",
          title2: "Période alerte non traitement (s)",
          placeholder: "Période en seconde ex: 100",
          required: "Période réquise",
          invalid: "Période invalide. Doit être supérieure ou égale 60"
        },
        uri: {
          title: "Chemin relatif",
          title2: "Chemin relatif de traitement",
          placeholder: "Chemin relatif ex: rel/folder/apps/",
          required: "Chémin relatif requis",
          invalid: "Chémin invalide"
        },
        alertFileRunningSince: {
          title: "Alerte durée fichier en cours (seconde)",
          placeholder: "Alerte durée ex: 500",
          required: "Durée requise",
          invalid: "Durée invalide. Doit être supérieure ou égale à 60"
        },
        fileSystemRoot: {
          title: "Chemin absolu",
          title2: "Chemin absolu de traiment",
          placeholder: "Chemin absolu ex: /opt/bulksms/",
          required: "Chemin absolu requis",
          invalid: "Chemin absolu invalide"
        },
        fileSizeLimit: {
          title: "Taile max (Ko)",
          title2: "Taille maximale du fichier (Ko)",
          placeholder: "Taille max. ex: 2000",
          required: "Taille maximale requise",
          invalid: "Taille maximale invalide"
        },
        alertNotFileAtTime: {
          title: "Alerte heure abscence fichier",
          placeholder: "Alerte en heure ex: 18:00:00",
          required: "Heure alerte requise",
          invalid: "Heure alerte invalide"
        },
        alertNotFileDay: {
          title: "Alerte jour(s) absence fichier",
          placeholder: "Alerte jour(s) absence fichier ex: 1234",
          required: "Jour(s) abscence fichier requise",
          invalid: "Jour(s) abscence fichier invalide"
        },
        created: {
          title: "Date"
        },
        state: {
          title: "Traitement"
        },
        status: {
          title: "Statut",
          title2: "Cocher pour activer le repertoire de traitement",
          enabled: "Activé",
          disabled: "Désactivé"
        },
        remote: {
          title: "Répertoire distant"
        }
      }
    },
    priorities: {
      title: "Files de traitement",
      notFound: "Priorité introuvable",
      btn: {
        new: "Nouvelle file",
        edit: "Modifier la file",
        delete: "Supprimer la file",
        start: "Démarrer la file",
        stop: "Arrêter la file"
      },
      create: {
        title: "Nouvelle file de traitement",
        success: "File enregistrée"
      },
      edit: {
        title: "Modifier la file de traitement",
        success: "File modifiée"
      },
      delete: {
        title: "Êtes vous sûre de vouloir supprimer cette file ?",
        success: "File supprimée",
        unable: "Impossible de supprimer la file"
      },
      changeStatus: {
        start: {
          title: "Êtes vous sûre de vouloir démmarer cette file ?",
          success: "Priorité en cours de démarrage"
        },
        stop: {
          title: "Êtes vous sûre de vouloir arrêter cette file ?",
          success: "Priorité en cours d'arrêt"
        }
      },
      model: {
        identifier: {
          title: "Identifiant",
          placeholder: "Identifiant unique de la priorité",
          required: "Identifiant requis"
        },
        label: {
          title: "Nom",
          placeholder: "Nom de la priorité",
          required: "Nom requis",
          maxLength: "Nom trop long. {0} carcatères max autorisés"
        },
        frequence: {
          title: "Fréquence",
          title2: "{0} SMS toutes les {1}s"
        },
        maxSms: {
          title: "Nombre max de sms",
          placeholder: "Nombre max de sms par parcours",
          required: "Nombre max de sms requis",
          between: "Nombre max de sms doit être compris entre {0} et {1}"
        },
        timer: {
          title: "Fréquence (s)",
          placeholder: "Fréquence de parcours (s)",
          required: "Féquence de parcours requise",
          between: "Fréquence de parcours doit être comprise entre {0} et {1}"
        },
        status: {
          title: "Statut",
          started: "Démarré",
          stopped: "Arrêté"
        },
        server: {
          title: "Serveur",
          placeholder: "Sélectionner un serveur",
          required: "Serveur requis",
          between: "L'identifiant doit être compris entre {0} and {1}"
        },
        lastExecutionDuration: {
          title: "Durée"
        },
        lastExecutionDate: {
          title: "Derniere execution"
        },
        email: {
          title: "Adresse email",
          placeholder: "Adresse email de notification",
          required: "Adresse email requise",
          invalid: "Adresse email invalide"
        },
        action: {
          title: "Cocher pour démarrer automatiquement la priorité"
        },
        apiErrorOnSend: {
          title: "Nombre d'echecs avant alerte",
          placeholder: "Nombre d'echecs avant alerte email",
          required: "Nombre d'echecs avant alerte requis",
          between: "Nombre d'echecs doit être compris entre {0} et {1}"
        },
        enableSourceWeight: {
          title: "Cocher pour traiter les sms par priorité. API, WEB, FICHIER"
        }
      }
    }
  },
  archives: {
    title: "Archives",
    btn: {
      downloadArchive: "Télécharger les archives"
    },
    download: {
      title: "Recevoir les archives par mail",
      success: "Demande d'archives encours de traitement"
    },
    model: {
      email: {
        title: "Adresses emails",
        placeholder: "Adresses emails de reception de l'archive",
        helper: "Adresses emails séparées par point virgule ;",
        required: "Au moins une adresse email requise",
        maxLength: "{0} caractères maximum autorisés",
        invalid: "Contient des adresses emails invalides"
      },
      created: {
        title: "Date"
      },
      user: {
        title: "Compte"
      },
      lineCount: {
        title: "Ligne(s)"
      },
      fileCount: {
        title: "Fichier(s)"
      },
      fileSize: {
        title: "Taille"
      }
    }
  },
  statistics: {
    period: {
      title: "Options d'affichage",
      help: "Cliquer sur le button pour modifier le jour",
      title2: "Statistique par mois",
      help2: "Cliquer sur le bouton pour modifier le mois"
    },
    details: {
      title: "Détails",
      days: {
        title: "Statistiques sms par jour",
        title2: "Statistiques par jour du {date)"
      },
      status: {
        title: "Statistiques sms par statuts"
      },
      telcos: {
        title: "Statistiques sms par opérateurs"
      },
      statusAndDay: {
        title: "Statistique sms par statuts et jours"
      }
    },
    filter: {
      title: "Filtrer les statistiques"
    },
    model: {
      total: {
        title: "Total",
        title2: "Totaux"
      },
      date: {
        title: "Date"
      },
      status: {
        title: "Statut"
      },
      telco: {
        title: "Opérateurs"
      },
      queue: {
        short_title: "En cours"
      },
      sms: {
        title: "Sms"
      },
      nextUpdate: {
        title: "Prochaine mise à jour à {0}"
      },
      sent: {
        title: "Sms envoyés",
        short_title: "Envoyés",
        description: "Nombre de sms envoyés"
      },
      delivered: {
        title: "Sms délivrés",
        short_title: "Délivrés",
        description: "Sms délivrés sur mobile"
      },
      pending: {
        title: "En attente d'accusés",
        short_title: "En attente",
        description: "En attente d'accusés de réception"
      },
      undelivered: {
        title: "Autres statuts",
        short_title: "Autres statuts",
        description: "Nombre de sms non reçus sur mobile"
      },
      noacked: {
        title: "Sms sans accusés",
        short_title: "Sans accusés"
      },
      username: {
        title: "Utilisateurs"
      },
      sms_amount: {
        title: "Nombre de sms"
      }
    },
    btn: {
      export: "Exporter les statistiques de tous les utilisateurs"
    }
  },
  developers: {
    title: "Développeurs",
    balance: {
      title: "Consulter le solde du compte"
    },
    php: {
      title: "Exemple d'intégration avec PHP + CURL"
    },
    nodejs: {
      title: "Exemple d'intégration avec NodeJS"
    }
  },
  logout: {
    title: "Déconnexion"
  },
  portail: {
    title: "Portail authentication",
    error: "Token de connexion invalide"
  }
};
